export interface SWRegistrationCallbacks {
  onUpdate?: (registration: ServiceWorkerRegistration) => void
  onSuccess?: (registration: ServiceWorkerRegistration) => void
}

export async function registerSW(
  callbacks?: SWRegistrationCallbacks,
): Promise<ServiceWorkerRegistration | undefined> {
  if (!('serviceWorker' in navigator)) return undefined

  try {
    const registration = await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
    })

    setInterval(() => {
      registration.update().catch(() => {})
    }, 60 * 1000)

    if (registration.installing) {
      trackInstalling(registration.installing, callbacks)
    } else if (registration.waiting) {
      callbacks?.onUpdate?.(registration)
    }

    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing
      if (newWorker) {
        trackInstalling(newWorker, callbacks)
      }
    })

    return registration
  } catch (err) {
    console.error('SW registration failed:', err)
    return undefined
  }
}

function trackInstalling(
  worker: ServiceWorker,
  callbacks?: SWRegistrationCallbacks,
): void {
  worker.addEventListener('statechange', () => {
    if (worker.state !== 'installed') return
    if (navigator.serviceWorker.controller) {
      callbacks?.onUpdate?.(worker as unknown as ServiceWorkerRegistration)
    } else {
      callbacks?.onSuccess?.(worker as unknown as ServiceWorkerRegistration)
    }
  })
}

export function skipWaiting(registration: ServiceWorkerRegistration): void {
  registration.waiting?.postMessage({ type: 'SKIP_WAITING' })
  window.location.reload()
}
